<template>
  <div
    v-if="visible"
    class="aj-message"
    :class="`-${type}`"
  >
    <div class="aj-message__wrapper">
      <slot
        v-if="iconVisible"
        name="icon"
      >
        <div class="aj-message__icon">
          <aj-icon :shape="icon" />
        </div>
      </slot>
      <div class="aj-message__content">
        <slot name="title">
          <p
            v-if="title"
            class="aj-message__title"
            v-html="title"
          />
        </slot>
        <slot name="message">
          <span
            v-if="message"
            class="aj-message__message"
            v-html="message"
          />
        </slot>
        <slot name="action">
          <aj-button
            v-if="actionLabel"
            class="aj-message__action"
            subtle-dark
            small
            @click="actionHandler"
          >
            {{ actionLabel }}
          </aj-button>
        </slot>
      </div>
    </div>
    <slot
      v-if="closable"
      name="close"
      v-bind="{ closeHandler }"
    >
      <aj-icon
        class="aj-message__close"
        shape="close-bold"
        @click="closeHandler"
      />
    </slot>
  </div>
</template>

<script>
import AjButton from '../AjButton/AjButton.vue';
import AjIcon from '../AjIcon/AjIcon.vue';

export default {
  name: 'AjMessage',

  components: {
    AjIcon,
    AjButton,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: true,
    },
    iconVisible: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    actionLabel: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'info',
    },
  },

  computed: {
    icon () {
      switch (this.type) {
        case 'success':
          return 'success';
        case 'info':
          return 'info';
        case 'error':
          return 'error-icon';
        default:
          return '';
      }
    },
  },

  methods: {
    closeHandler () {
      this.$emit('click:close');
    },
    actionHandler () {
      this.$emit('click:action');
    },
  },
};
</script>

<style lang="scss" src="./AjMessage.scss" />
